import {InnerAvatar} from './inner_avatar'
import {IconAvatar, ImageAvatar, InitialsAvatar, OpenShiftAvatar, UserAvatar, UserAvatarWithUserId} from './avatar_types'
import './styles/index.less'

export const Avatar = props => {
	const {icon, type, user, userId, imageSrc, initials, radius = 32} = props

	let Component = InnerAvatar
	if (type === 'open-shift') Component = OpenShiftAvatar
	if (initials) Component = InitialsAvatar
	if (icon) Component = IconAvatar
	if (user) Component = UserAvatar
	if (userId) Component = UserAvatarWithUserId
	if (imageSrc) Component = ImageAvatar

	return <Component radius={radius} {...props} />
}
